export default {
      id: "Icon--jumpDown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--jumpDown",
      toString: function () {
        return this.url;
      }
    }